<div
  [ngClass]="{
    'lg:w-[624px]': width() === 'sm',
    'lg:w-[842px]': width() === 'lg',
    'lg:w-[1280px]': width() === 'xl',
  }"
  class="w-full flex flex-col max-h-[calc(100dvh-32px)]"
>
  <ng-content select="[dialog-top]" />
  @if (!noDialogTitle()) {
    <div mat-dialog-title>
      <div class="flex justify-between items-center mt-6">
        <div class="flex gap-4 items-center">
          <ui-headline><ng-content select="[dialog-title]" /></ui-headline>
          <ng-content select="[dialog-title-info]" />
        </div>
        <button class="big-rounded-button" mat-icon-button (click)="closeIconClicked()">
          <mat-icon svgIcon="cp-close" />
        </button>
      </div>
    </div>

    @if (titleDivider()) {
      <ui-divider />
    }
  }
  <div mat-dialog-content>
    <ng-content select="[dialog-content]" />
  </div>
  @if (!noDialogActions()) {
    @if (actionDivider()) {
      <ui-divider />
    }
    <div mat-dialog-actions>
      <div
        class="w-full flex flex-col md:flex-row justify-center md:justify-between flex-wrap items-end has-[button:only-child]:justify-end p-4 md:p-6"
      >
        <ng-content select="[dialog-actions]" />
      </div>
      <ng-content select="[dialog-extras]" />
    </div>
  }
</div>
